import { atom } from 'recoil';

const KEY = 'diamondBalance';

export default atom({
  key: KEY,
  default: 0,
});

// TODO - Should crap out if unable to fetch balance not default to zero ->
//        Will need to update this here
